var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlBody2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 618,
    height: 704,
    viewBox: "0 0 618 704",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Body / 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skin color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.271 514.385L79.221 466.255C69.1295 472.814 59.7328 473.752 51.9098 474.533C43.8736 475.335 37.4979 475.972 33.735 482.365C26.229 495.113 19.083 520.105 15.605 534.799C14.171 540.869 15.879 562.061 19.307 573.687C21.249 580.269 25.537 586.375 25.537 586.375C25.537 586.375 30.687 598.473 32.695 599.529C38.367 602.513 40.871 596.691 40.871 596.691C40.871 596.691 44.695 614.161 48.591 612.453C50.993 611.397 54.519 608.131 54.607 603.783C55.163 576.099 60.585 547.179 70.099 542.187C76.2075 538.982 78.418 549.864 80.4877 560.054C81.6415 565.735 82.7516 571.2 84.469 573.889C89.121 581.175 107.435 586.367 102.813 573.633C96.4793 556.186 96.3221 548.855 96.0876 537.925C96.0765 537.407 96.0652 536.881 96.053 536.345C95.785 524.509 94.271 514.385 94.271 514.385ZM478.055 473.197C478.055 473.197 455.451 476.037 451.149 486.157C438.843 515.097 464.345 566.833 464.345 566.833C464.345 566.833 453.537 560.243 451.387 566.007C450.431 568.573 448.263 589.069 488.743 590.449C493.039 590.595 503.379 581.853 503.379 581.853C503.379 581.853 495.841 596.247 507.383 599.075C507.383 599.075 525.985 571.203 526.271 565.001C526.555 558.797 520.585 527.403 517.357 521.063C514.127 514.721 478.055 473.197 478.055 473.197Z",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 6",
    opacity: 0.15139,
    d: "M472.61 510.585C472.61 510.585 478.29 532.043 497.784 538.729C504.6 541.067 502.898 568.665 519.606 565.365",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sweater color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sweater",
    d: "M227.967 44.1228L239.597 20.0005L279.503 22.9505L293.321 47.1465L308.395 25.4865L320.975 28.0485L327.162 49.663C349.93 52.338 366.069 57.6521 381.241 71.5697C433.721 119.75 437.561 300.11 437.561 300.11L502.619 438.272C513.021 460.37 500.841 486.492 477.241 492.73L460.581 497.152C431.699 504.79 401.699 489.412 391.041 461.492L380.641 434.272L371.241 342.21L197.601 339.652C197.601 339.652 199.101 323.49 195.401 300.092C190.581 269.512 173.181 246.712 173.181 246.712L141.741 285.392L125.619 431.79C122.961 455.932 103.781 474.912 79.6186 477.31L46.9006 480.572C21.6986 483.072 -0.119385 463.21 0.000614747 437.89C0.260615 385.092 4.06061 299.69 23.8406 243.61C50.3806 168.272 127.581 86.2897 165.421 62.4497C187.421 48.5903 208.188 44.6352 227.967 44.1228Z",
    fill: "#72A065"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 15",
    opacity: 0.199335,
    d: "M369.641 341.759C376.055 260.273 420.465 243.043 388.465 151.659",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 19",
    opacity: 0.199335,
    d: "M212.159 187.658L173.185 246.708",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Neck shadow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Neck shadow_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.937 48.8366L273.321 30.6826L258.091 57.4526L283.937 48.8366ZM324.655 57.4994L311.385 30.7314L302.137 48.8854L324.655 57.4994Z",
    fill: "#2437A8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlBody2);
export default __webpack_public_path__ + "static/media/Girl-Body-2.b6cb958d.svg";
export { ForwardRef as ReactComponent };